export class MetaAdsProvider {
	protected currency: string;

	constructor(currency: string) {
		this.currency = currency;
	}

	#trackEvent(eventName: string, eventParams?: Record<string, unknown>) {
		if (typeof fbq !== 'undefined') {
			fbq('track', eventName, eventParams);
		}
	}

	trackInitiateCheckout() {
		this.#trackEvent('InitiateCheckout');
	}

	trackAddToCart(variant: Variant, quantity: number) {
		this.#trackEvent('AddToCart', {
			content_type: 'product',
			content_ids: [variant.data.sku],
			value: (variant.special_price ?? variant.price!) * quantity,
			currency: this.currency,
		});
	}

	trackViewContent(product: Product, price: number) {
		this.#trackEvent('ViewContent', {
			content_type: 'product',
			content_ids: [product.data.sku],
			value: price,
			currency: this.currency,
			content_name: product.data.name,
		});
	}

	trackViewContentVariant(product: Product, variant: Variant) {
		this.#trackEvent('ViewContent', {
			content_type: 'product',
			content_ids: [variant?.data.sku ?? product.data.sku],
			value: variant.special_price ?? variant.price!,
			currency: this.currency,
			content_name: product.data.name,
		});
	}

	trackConversion(order: SalesOrder) {
		this.#trackEvent('Purchase', {
			value: order.grand_total.toFixed(2),
			currency: this.currency,
			// @TODO: Handle bundles when implemented (specify each product sku in bundle)
			content_ids: order.items.map((item) => item.sku),
			content_type: 'product',
			num_items: order.items.length,
		});
	}
}

export default MetaAdsProvider;
